// @mui
import Container from '@mui/material/Container';
// hooks
// _mock
// components
import { useSettingsContext } from 'src/components/settings';
import MarketUserTable from './marketing-table';
// assets
//

// ----------------------------------------------------------------------

export default function MarketingAdmin() {
    // const { user } = useMockedUser();
    const settings = useSettingsContext();
    return (
        <Container maxWidth={ settings.themeStretch ? false : 'xl' }>
            <MarketUserTable />
        </Container >
    );
}
